import React, {ReactNode} from "react";
import styles from './styles.module.scss'

export function InfoBoxItem({title, children}: { title: string, children: ReactNode }) {
  return (
    <div>
      <div className={'pkt-txt-16-medium'}>{title}</div>
      <div className={`pkt-txt-16-light mt-size-4`}>{children}</div>
    </div>
  )
}

export function InfoBox({children, className, ...restProps}: React.HTMLAttributes<HTMLDivElement>) {
  const classes = [className, styles.infoBox].filter(Boolean).join(' ')
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  )
}